import { GroupNode } from "@logicflow/extension";


class MyGroup extends GroupNode.view {

}

class MyGroupModel extends GroupNode.model {
    setAttributes(){
        if (this.hasOwnProperty("properties")) {
           let data = this.properties;


            if (data && data.hasOwnProperty("nodeSize")) {
                const {nodeSize} = data;
                let tt=this.text?this.text:{value:'ee',x:0,y:0}
                tt = {
                    value:  tt.value||'',
                    x: this.x  - nodeSize.width / 2 +15,
                    y: this.y  - nodeSize.height / 2 + 8
                }
                this.text=tt;
            }
        }
    }
    initNodeData(data) {
        this.text.draggable = true;

        super.initNodeData(data);
        this.foldable = false;
        // this.isRestrict = true;
        this.resizable = true;
        this.width = 400;
        this.height = 200;
        const noTarget = {
            message: "不允许连接分组",
            validate: (sourceNode, targetNode, sourceAnchor, targetAnchor) => {
                return false;
            }
        };
        this.targetRules.push(noTarget);
    }
    getNodeStyle() {
        const style = super.getNodeStyle();
        style.stroke = "#ad896f";
        style.strokeWidth = 1;
        style.strokeDasharray = "5 5";
        if (this.isSelected) {
            style.stroke = "rgb(124, 15, 255)";
        }

        return style;
    }
    // 隐藏锚点而不是设置锚点数为0
    // 因为分组内部节点与外部节点相连时，
    // 如果折叠分组，需要分组代替内部节点与外部节点相连。
    getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.stroke = "transparent";
        style.fill = "none";
        style.hover.stroke = "transparent";
        return style;
    }
}
export default {
    type: "subprocess",
    model: MyGroupModel,
    view: MyGroup
};
